import { useMutation } from '@apollo/client'
import { DELETE_EVENT_DAY } from './operations'
import { DeleteEventDayVariables, DeleteEventDay } from '../../types/operation-types'

interface Props {
  onCompleted?: () => void
}

export const useDeleteEventDay = ({ onCompleted }: Props) =>
  useMutation<DeleteEventDay, DeleteEventDayVariables>(DELETE_EVENT_DAY, { onCompleted })
